import { lazy } from "react";
import { Navigate } from "react-router-dom";

const lazyPage = (importPage) => lazy(importPage);

export const LandingLayout = lazyPage(() => import("../pages/landing"));
export const LandingDashboard = lazyPage(() => import("../pages/landing/dashboard"));
export const AuthLogin = lazyPage(() => import("../pages/shared/AuthLogin"));
export const Register = lazyPage(() => import("../pages/landing/Register"));
export const ForgotPassword = lazyPage(() => import("../pages/landing/ForgotPassword"));
export const NewPassword = lazyPage(() => import("../pages/landing/NewPassword"));

export const ClinicLayout = lazyPage(() => import("../pages/clinic"));
export const ClinicDashboard = lazyPage(() => import("../pages/clinic/Dashboard"));
export const Appointment = lazyPage(() => import("../pages/clinic/Appointment"));
export const AppointmentDetails = lazyPage(() => import("../pages/clinic/AppointmentDetails"));
export const Doctor = lazyPage(() => import("../pages/clinic/Doctor"));
export const Clinics = lazyPage(() => import("../pages/clinic/Clinics"));
export const Patient = lazyPage(() => import("../pages/clinic/Patient"));
export const PatientDetails = lazyPage(() => import("../pages/clinic/PatientDetails"));
export const Receptionist = lazyPage(() => import("../pages/clinic/Receptionist"));
export const Category = lazyPage(() => import("../pages/clinic/Category"));
export const Services = lazyPage(() => import("../pages/clinic/Services"));
export const CreatePrescription = lazyPage(() => import("../pages/clinic/CreatePrescription"));
export const Settings = lazyPage(() => import("../pages/clinic/Settings"));
export const ClinicSubscription = lazyPage(() => import("../pages/clinic/Subscription"));
export const ClinicSetup = lazyPage(() => import("../pages/clinic/ClinicSetup"));
export const ClinicFinance = lazyPage(() => import("../pages/clinic/ClinicFinance"));
export const ClinicDoctorPayments = lazyPage(() => import("../pages/clinic/ClinicDoctorPayments"));
export const ClinicActivityLogs = lazyPage(() => import("../pages/clinic/ActivityLogs"));
export const InternalChat = lazyPage(() => import("../pages/clinic/InternalChat"));
export const PharmacyInventory = lazyPage(() => import("../pages/clinic/PharmacyInventory"));
export const Tax = lazyPage(() => import("../pages/Finance/Tax"));
export const BillingRecord = lazyPage(() => import("../pages/Finance/BillingRecord"));
export const DoctorEarning = lazyPage(() => import("../pages/Finance/DoctorEarning"));
export const DoctorPayout = lazyPage(() => import("../pages/Finance/DoctorPayout"));

export const AdminLayout = lazyPage(() => import("../pages/admin"));
export const AdminDashboard = lazyPage(() => import("../pages/admin/AdminDashboard"));
export const Users = lazyPage(() => import("../pages/admin/Users"));
export const AdminClinics = lazyPage(() => import("../pages/admin/Clinics"));
export const AdminClinicDetails = lazyPage(() => import("../pages/admin/AdminClinicDetails"));
export const AdminCategory = lazyPage(() => import("../pages/admin/AdminCategory"));
export const AdminService = lazyPage(() => import("../pages/admin/AdminService"));
export const AdminDoctor = lazyPage(() => import("../pages/admin/AdminDoctor"));
export const AdminReceptionist = lazyPage(() => import("../pages/admin/AdminReceptionist"));
export const AdminMedicalReport = lazyPage(() => import("../pages/admin/AdminMedicalReport"));
export const AdminPrescription = lazyPage(() => import("../pages/admin/AdminPrescription"));
export const AdminPatient = lazyPage(() => import("../pages/admin/AdminPatient"));
export const AdminPatientDetails = lazyPage(() => import("../pages/admin/AdminPatientDetails"));
export const AdminAppointment = lazyPage(() => import("../pages/admin/AdminAppointment"));
export const AdminTax = lazyPage(() => import("../pages/admin/AdminTax"));
export const AdminBilling = lazyPage(() => import("../pages/admin/AdminBilling"));
export const AdminDoctorEarning = lazyPage(() => import("../pages/admin/AdminDoctorEarning"));
export const AdminDoctorPayout = lazyPage(() => import("../pages/admin/AdminDoctorPayout"));
export const AdminDoctorPayments = lazyPage(() => import("../pages/admin/AdminDoctorPayments"));
export const AdminFinance = lazyPage(() => import("../pages/admin/AdminFinance"));
export const AdminPeople = lazyPage(() => import("../pages/admin/AdminPeople"));
export const AdminSetup = lazyPage(() => import("../pages/admin/AdminSetup"));
export const AdminSettings = lazyPage(() => import("../pages/admin/AdminSettings"));
export const AdminSaas = lazyPage(() => import("../pages/admin/AdminSaas"));
export const AdminStaff = lazyPage(() => import("../pages/admin/AdminStaff"));

export const landingRoutes = [
  { path: "login", element: <AuthLogin /> },
  { path: "doctor/login", element: <AuthLogin role="doctor" /> },
  { path: "receptionist/login", element: <AuthLogin role="receptionist" /> },
  { path: "register", element: <Register /> },
  { path: "forgotPassword", element: <ForgotPassword /> },
  { path: "newPassword", element: <NewPassword /> },
  { path: "set-password", element: <NewPassword /> },
];

export const adminRoutes = [
  { index: true, element: <AdminDashboard /> },
  { path: "people", element: <AdminPeople />, adminPermission: "people.view" },
  { path: "users", element: <Navigate to="/admin/people?tab=users" replace /> },
  { path: "clinics", element: <AdminClinics />, adminPermission: "clinics.view" },
  { path: "clinics/:id", element: <AdminClinicDetails />, adminPermission: "clinics.view" },
  { path: "setup", element: <AdminSetup />, adminPermission: "setup.manage" },
  { path: "categories", element: <Navigate to="/admin/setup?tab=categories" replace /> },
  { path: "services", element: <Navigate to="/admin/setup?tab=services" replace /> },
  { path: "doctors", element: <AdminDoctor />, adminPermission: "doctors.manage" },
  { path: "receptionists", element: <Navigate to="/admin/people?tab=receptionists" replace /> },
  { path: "medical-reports", element: <AdminMedicalReport />, adminPermission: "reports.view" },
  { path: "prescriptions", element: <AdminPrescription />, adminPermission: "prescriptions.view" },
  { path: "patients", element: <AdminPatient />, adminPermission: "patients.manage" },
  { path: "patients/:id", element: <AdminPatientDetails />, adminPermission: "patients.manage" },
  { path: "appointments", element: <AdminAppointment />, adminPermission: "appointments.manage" },
  { path: "finance", element: <AdminFinance />, adminPermission: "finance.view" },
  { path: "saas", element: <AdminSaas />, adminPermission: "saas.manage" },
  { path: "staff", element: <AdminStaff />, adminPermission: "staff.manage" },
  { path: "tax", element: <Navigate to="/admin/finance?tab=tax" replace /> },
  { path: "billing", element: <Navigate to="/admin/finance?tab=billing" replace /> },
  { path: "doctor-payments", element: <AdminDoctorPayments />, adminPermission: "doctorPayments.view" },
  {
    path: "doctor-earning",
    element: <Navigate to="/admin/doctor-payments?tab=earnings" replace />,
  },
  {
    path: "doctor-payout",
    element: <Navigate to="/admin/doctor-payments?tab=payouts" replace />,
  },
  { path: "settings", element: <AdminSettings />, adminPermission: "settings.manage" },
];

export const clinicRoutes = [
  { index: true, element: <ClinicDashboard />, allowedRoles: ["clinic", "doctor", "receptionist"] },
  { path: "appointment", element: <Appointment />, allowedRoles: ["clinic", "doctor", "receptionist"] },
  { path: "appointment/:id", element: <AppointmentDetails />, allowedRoles: ["clinic", "doctor", "receptionist"] },
  { path: "appointment/createPrescription/:id", element: <CreatePrescription />, allowedRoles: ["clinic", "doctor"] },
  { path: "doctor", element: <Doctor />, allowedRoles: ["clinic", "receptionist"] },
  { path: "clinics", element: <Clinics />, allowedRoles: ["clinic"] },
  { path: "patient", element: <Patient />, allowedRoles: ["clinic", "doctor", "receptionist"] },
  { path: "patient-details", element: <PatientDetails />, allowedRoles: ["clinic", "doctor", "receptionist"] },
  { path: "receptionist", element: <Receptionist />, allowedRoles: ["clinic"] },
  { path: "setup", element: <ClinicSetup />, allowedRoles: ["clinic"] },
  { path: "category", element: <Navigate to="/clinic/setup?tab=categories" replace />, allowedRoles: ["clinic"] },
  { path: "specialisation", element: <Navigate to="/clinic/setup?tab=services" replace />, allowedRoles: ["clinic"] },
  { path: "createPrescription", element: <CreatePrescription />, allowedRoles: ["clinic", "doctor"] },
  { path: "finance", element: <ClinicFinance />, allowedRoles: ["clinic", "receptionist"] },
  { path: "subscription", element: <ClinicSubscription />, allowedRoles: ["clinic"] },
  { path: "finance/tax", element: <Navigate to="/clinic/finance?tab=tax" replace />, allowedRoles: ["clinic"] },
  { path: "finance/billing", element: <Navigate to="/clinic/finance?tab=billing" replace />, allowedRoles: ["clinic", "receptionist"] },
  { path: "doctor-payments", element: <ClinicDoctorPayments />, allowedRoles: ["clinic", "doctor"] },
  { path: "finance/doctor-earning", element: <Navigate to="/clinic/doctor-payments?tab=earnings" replace />, allowedRoles: ["clinic", "doctor"] },
  { path: "finance/doctor-payout", element: <Navigate to="/clinic/doctor-payments?tab=payouts" replace />, allowedRoles: ["clinic", "doctor"] },
  { path: "internal-chat", element: <InternalChat />, allowedRoles: ["clinic", "doctor", "receptionist"] },
  { path: "pharmacy-inventory", element: <PharmacyInventory />, allowedRoles: ["clinic", "receptionist"] },
  { path: "activity-logs", element: <ClinicActivityLogs />, allowedRoles: ["clinic"] },
  { path: "settings", element: <Settings />, allowedRoles: ["clinic", "doctor", "receptionist"] },
];
